module.exports = __webpack_public_path__ + "static/media/cloudy-night-1.7e65840b.svg";